export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  areaID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  },
  stateID: {
    value: [],
    options: [],
    clearOption: false,
    defaultArray: true,
    required: false,
    state: null
  },
  cityID: {
    value: [],
    options: [],
    clearOption: true,
    defaultArray: true,
    required: false,
    state: null
  },
  stateList: {
    value: [],
    options: [],
    clearOption: true,
    defaultArray: true,
    required: false,
    state: null
  },
  cityList: {
    value: [],
    options: [],
    clearOption: true,
    defaultArray: true,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/regionservice/regionservice-form.js